import { useSelector } from 'react-redux';
import { GlobalGuide } from '../../models';
import { selectGlobalGuides } from '../../selectors';

export const useGlobalGuides = (): GlobalGuide[] | null => {
  const globalGuides = useSelector(selectGlobalGuides);

  return globalGuides;
};
